/* eslint-disable react/prop-types */
import type {
  ComponentProps,
  ComponentPropsWithoutRef,
  ElementRef,
  HTMLAttributes,
  Ref,
} from 'react';

import { Drawer as DrawerPrimitive } from 'vaul';

import { cn } from 'src/utils/classNamesHelper';

const Drawer = ({
  shouldScaleBackground = true,
  ...props
}: ComponentProps<typeof DrawerPrimitive.Root>) => (
  <DrawerPrimitive.Root
    shouldScaleBackground={shouldScaleBackground}
    direction="right"
    {...props}
  />
);
Drawer.displayName = 'Drawer';

const DrawerTrigger = DrawerPrimitive.Trigger;

const DrawerPortal = DrawerPrimitive.Portal;

const DrawerClose = DrawerPrimitive.Close;

function DrawerOverlay({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof DrawerPrimitive.Overlay> & {
  ref?: Ref<ElementRef<typeof DrawerPrimitive.Overlay>>;
}) {
  return (
    <DrawerPrimitive.Overlay
      ref={ref}
      className={cn(
        'fixed inset-0 z-50 animate-fade-in bg-black/20',
        className
      )}
      {...props}
    />
  );
}
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;

function DrawerContent({
  className,
  children,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof DrawerPrimitive.Content> & {
  ref?: Ref<ElementRef<typeof DrawerPrimitive.Content>>;
}) {
  return (
    <DrawerPrimitive.Content
      ref={ref}
      className={cn(
        'fixed top-0 right-0 bottom-0 z-50 ml-24 flex h-full gap-4 bg-neutral-light-1 shadow-sheet outline-hidden',
        className
      )}
      {...props}
    >
      {/* <div className="my-auto ml-6 h-[100px] w-[3px] rounded-sm bg-neutral-light-4" /> */}
      {children}
    </DrawerPrimitive.Content>
  );
}
DrawerContent.displayName = 'DrawerContent';

const DrawerHeader = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('gap-1.5 grid p-4 text-center sm:text-left', className)}
    {...props}
  />
);
DrawerHeader.displayName = 'DrawerHeader';

const DrawerFooter = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('mt-auto flex flex-col gap-2 p-4', className)}
    {...props}
  />
);
DrawerFooter.displayName = 'DrawerFooter';

function DrawerTitle({
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof DrawerPrimitive.Title> & {
  ref?: Ref<ElementRef<typeof DrawerPrimitive.Title>>;
}) {
  return <DrawerPrimitive.Title ref={ref} asChild {...props} />;
}
DrawerTitle.displayName = DrawerPrimitive.Title.displayName;

function DrawerDescription({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof DrawerPrimitive.Description> & {
  ref?: Ref<ElementRef<typeof DrawerPrimitive.Description>>;
}) {
  return (
    <DrawerPrimitive.Description
      ref={ref}
      className={cn('text-muted-foreground text-sm', className)}
      {...props}
    />
  );
}
DrawerDescription.displayName = DrawerPrimitive.Description.displayName;

export {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
};
